(function () {
  var root = document.querySelector('[data-desal-hero-carousel]');
  if (!root) return;

  /* Opening slide is chosen + reordered to DOM index 0 by an inline pre-paint
     script in sections/desal-hero-carousel.liquid (so the shuffle never causes a
     visible post-paint cross-fade flicker). Do NOT shuffle again here. */

  var slides = root.querySelectorAll('.desal-hero__slide');
  var dots = root.querySelectorAll('.desal-hero__dots button');
  var prevBtn = root.querySelector('[data-desal-hero-prev]');
  var nextBtn = root.querySelector('[data-desal-hero-next]');
  var buttons = root.querySelectorAll('.desal-hero__btn');
  var section = root.closest('.desal-hero-section, .shopify-section');
  var index = 0;
  var timer;
  var resizeObserver;

  // Mark JS-present so the CSS entrance hidden-state applies (no-JS sees all).
  root.setAttribute('data-js', '');

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer =
    window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

  function getAnnouncementEl() {
    return document.querySelector('.header-announcements, .announcement-bar');
  }

  function getViewportHeight() {
    return Math.max(
      window.innerHeight || 0,
      document.documentElement.clientHeight || 0,
      window.visualViewport ? window.visualViewport.height : 0
    );
  }

  /**
   * Horizon pulls the first section up under the transparent header (negative margin-top).
   * Add that overlap back so the hero still reaches the bottom of the viewport.
   */
  function getTransparentHeaderOverlap() {
    var header = document.querySelector('header-component[transparent], .header[transparent]');
    if (!header) return 0;

    var groupH = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-group-height')
    );
    var headerH = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );

    if (groupH > 0) return Math.ceil(groupH);
    if (headerH > 0) return Math.ceil(headerH);
    return Math.ceil(header.offsetHeight || 0);
  }

  function setHeroHeight() {
    var ann = getAnnouncementEl();
    var annH = ann ? Math.ceil(ann.getBoundingClientRect().height) : 0;
    var overlap = getTransparentHeaderOverlap();
    var buffer = 0.5;
    // The header sits on its own white band at the top of the hero (both
    // breakpoints) and the slides start below it, so the logo/menu never sit
    // on the artwork. Measure the real header element — the CSS overlap vars
    // under-report on mobile.
    var headerEl = document.querySelector('header-component, .header, #header-component');
    var hh = headerEl ? Math.ceil(headerEl.getBoundingClientRect().height) : Math.ceil(overlap);
    // Slides start a slim strip below the top so the image rises up behind the
    // (transparent) header and its top edge sits just under the announcement
    // bar — not flush against it. Tune BAND to taste. ponytail: fixed 0.2 of
    // header height, promote to a section setting if it needs per-page control.
    var isMobileVP = window.matchMedia('(max-width: 749px)').matches;
    // Mobile pushes the image down an extra 0.2·hh so the baked-in copy clears
    // the header icons (0.4 vs 0.2 on desktop).
    var band = Math.round(hh * (isMobileVP ? 0.7 : 0.2));
    // Hero covers ~75% of the screen so the products section peeks in below it.
    var full = getViewportHeight() - annH + overlap + buffer;
    var h = Math.round(full * 0.75) + band;
    if (isMobileVP) {
      // Mobile creatives are 1080×1350 with baked-in copy: the image area
      // below the band matches the exact 4:5 ratio, so nothing crops.
      var w = root.clientWidth || window.innerWidth;
      h = Math.round(w * (1350 / 1080) + band);
    }
    root.style.setProperty('--desal-hero-track-top', band + 'px');
    h = Math.max(h, 320);

    document.documentElement.style.setProperty('--desal-announcement-height', annH + 'px');
    document.documentElement.style.setProperty('--desal-header-overlap', overlap + 'px');
    document.documentElement.style.setProperty('--desal-hero-height', h + 'px');

    root.style.height = h + 'px';
    if (section) {
      section.style.minHeight = h + 'px';
    }
  }

  function show(i) {
    index = (i + slides.length) % slides.length;
    slides.forEach(function (s, n) {
      var active = n === index;
      s.classList.toggle('is-active', active);
      // Restart the Ken Burns drift from scratch on the newly active slide so
      // every reveal pans freshly (CSS animation otherwise won't replay).
      if (active && !reduceMotion) {
        var img = s.querySelector('img');
        if (img) {
          img.style.animation = 'none';
          // force reflow, then clear to let the stylesheet animation re-run
          void img.offsetWidth;
          img.style.animation = '';
        }
      }
    });
    dots.forEach(function (d, n) {
      d.classList.toggle('is-active', n === index);
    });
  }

  function next() {
    show(index + 1);
  }

  function prev() {
    show(index - 1);
  }

  function start() {
    stop();
    timer = setInterval(next, 5500);
  }

  function stop() {
    if (timer) clearInterval(timer);
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      show(parseInt(dot.getAttribute('data-slide'), 10) || 0);
      start();
    });
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      prev();
      start();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      next();
      start();
    });
  }

  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);

  /* ---- Touch swipe: horizontal drag flips slides. Only fires when the gesture
     is clearly horizontal (dx > dy) so vertical page scroll is untouched. ---- */
  (function swipe() {
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      x0 = t.clientX; y0 = t.clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        dx < 0 ? next() : prev();
        start();
      }
      x0 = y0 = null;
    }, { passive: true });
  })();

  /* ---- Arrow auto-hide: arrows appear on movement (scroll, swipe, mouse)
     and fade out after 5s of inactivity. Hidden by default on load. ---- */
  (function arrowAutoHide() {
    if (!prevBtn && !nextBtn) return;
    var hideTimer;
    function showArrows() {
      root.classList.add('show-arrows');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        root.classList.remove('show-arrows');
      }, 5000);
    }
    window.addEventListener('scroll', showArrows, { passive: true });
    ['touchstart', 'mousemove', 'pointerdown'].forEach(function (ev) {
      root.addEventListener(ev, showArrows, { passive: true });
    });
    [prevBtn, nextBtn].forEach(function (b) {
      if (b) b.addEventListener('focus', showArrows);
    });
  })();

  function bindResize() {
    setHeroHeight();
    window.addEventListener('resize', setHeroHeight);
    window.addEventListener('orientationchange', setHeroHeight);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', setHeroHeight);
    }

    var ann = getAnnouncementEl();
    if (ann && typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(setHeroHeight);
      resizeObserver.observe(ann);
    }

    var header = document.querySelector('header-component, #header-component');
    if (header && typeof ResizeObserver !== 'undefined') {
      var headerObs = new ResizeObserver(setHeroHeight);
      headerObs.observe(header);
    }
  }

  bindResize();
  window.addEventListener('load', function () {
    setTimeout(setHeroHeight, 50);
    setTimeout(setHeroHeight, 300);
  });
  document.addEventListener('DOMContentLoaded', setHeroHeight);

  /* ---- Staggered entrance: flip [data-loaded] once we're painted. ---- */
  function reveal() {
    // double-rAF guarantees the hidden initial state is committed first, so the
    // transition actually plays rather than snapping.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.setAttribute('data-loaded', '');
      });
    });
  }
  if (document.readyState === 'complete') {
    reveal();
  } else {
    window.addEventListener('load', reveal, { once: true });
    // Fallback so CTAs never stay hidden if 'load' is delayed by heavy assets.
    setTimeout(reveal, 1200);
  }

  /* ---- Parallax: subtle translateY on the active image as the hero scrolls
     out. rAF-throttled, GPU-composited via the --desal-hero-parallax var the
     CSS Ken Burns keyframe folds in. Disabled under reduced-motion. ---- */
  if (!reduceMotion) {
    var maxShift = isMobile ? 14 : 30; // px, kept subtle
    var ticking = false;

    function applyParallax() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      // Only compute while the hero is anywhere near the viewport.
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      // 0 at top of page, grows as hero scrolls up out of view.
      var scrolled = -rect.top;
      var h = rect.height || 1;
      var progress = Math.min(Math.max(scrolled / h, 0), 1);
      var shift = (progress * maxShift).toFixed(2);
      root.style.setProperty('--desal-hero-parallax', shift + 'px');
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(applyParallax);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    applyParallax();
  }

  /* ---- Magnetic CTAs: gentle pull toward the cursor. Fine-pointer only,
     rAF-throttled, reduced-motion guarded. Sets --mx/--my that the CSS
     transform composites with the hover lift. ---- */
  if (finePointer && !reduceMotion && !isMobile) {
    var strength = 0.28; // fraction of offset from centre
    var maxPull = 12; // px clamp

    buttons.forEach(function (btn) {
      var pending = false;
      var lastX = 0;
      var lastY = 0;

      function update() {
        pending = false;
        var rect = btn.getBoundingClientRect();
        var dx = lastX - (rect.left + rect.width / 2);
        var dy = lastY - (rect.top + rect.height / 2);
        var mx = Math.max(-maxPull, Math.min(maxPull, dx * strength));
        var my = Math.max(-maxPull, Math.min(maxPull, dy * strength));
        btn.style.setProperty('--mx', mx.toFixed(2) + 'px');
        btn.style.setProperty('--my', my.toFixed(2) + 'px');
      }

      btn.addEventListener('mousemove', function (e) {
        lastX = e.clientX;
        lastY = e.clientY;
        if (!pending) {
          pending = true;
          requestAnimationFrame(update);
        }
      });

      btn.addEventListener('mouseleave', function () {
        btn.style.setProperty('--mx', '0px');
        btn.style.setProperty('--my', '0px');
      });
    });
  }

  start();
})();

/* ---------------------------------------------------------------------------
   Primary hero CTA — rotating "flip" text through a few brand messages.
   Link stays the same (#our-products); only the label cycles. Width is locked
   to the widest message so the button never reflows. Reduced-motion = static.
--------------------------------------------------------------------------- */
(function () {
  var label = document.querySelector('[data-hero-rotate] .desal-hero__btn-label');
  if (!label) return;

  var TEXTS = ['Discover Products', 'Beat Hard Water', 'Reverse The Damage', 'Follow The Science'];

  function lockWidth() {
    var orig = label.textContent, max = 0;
    label.style.width = 'auto';
    TEXTS.forEach(function (t) { label.textContent = t; max = Math.max(max, label.offsetWidth); });
    label.textContent = orig;
    label.style.width = Math.ceil(max) + 'px';
  }
  lockWidth();
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(lockWidth).catch(function () {}); }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var i = 0, timer = null;
  function flip() {
    label.style.transform = 'rotateX(90deg)';
    label.style.opacity = '0';
    setTimeout(function () {
      i = (i + 1) % TEXTS.length;
      label.textContent = TEXTS[i];
      label.style.transition = 'none';
      label.style.transform = 'rotateX(-90deg)';
      void label.offsetWidth;            /* commit the jump with no transition */
      label.style.transition = '';
      label.style.transform = 'rotateX(0deg)';
      label.style.opacity = '1';
    }, 340);
  }
  function run() { clearInterval(timer); timer = setInterval(flip, 3200); }
  run();
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { clearInterval(timer); } else { run(); }
  });
})();
